type Base64ToBase64Url = (base64: string) => string

export const base64ToBase64Url: Base64ToBase64Url = (base64: string) => {
  // Replace '+' with '-' and '/' with '_'
  // To convert the characters in Base64Url to Base64 these characters need to be replaced:
  // 1. '+' --> '-'
  // 2. '/' --> '_'
  const base64url = base64.replace(/\+/g, '-').replace(/\//g, '_')

  // Padding characters are not needed in Base64Url encoding.
  const withoutPadding = base64url.replace(/=+$/, '')

  return withoutPadding
}
